<ispui-preloader-round
  view="overlay"
  [loading]="button.preloaderSubject | async"
  [spinnerSize]="25"
>
  <button
    class="button"
    ispuiButton
    type="button"
    [class.button_full-width]="button.fullWidth"
    [class.button_with-text]="button.label"
    [theme]="button.theme"
    [size]="button.size"
    [icon]="!button.label"
    [disabled]="button.disabledSubject | async"
    [attr.data-ispui-tooltip-text]="hint | async"
    [attr.data-ispui-tooltip-disabled]="!(hint | async)"
    [attr.data-ispui-tooltip-attach-selector]="hintAttachSelector"
    [attr.data-ispui-tooltip-scroll-selector]="hintAttachSelector"
    [attr.data-ispui-tooltip-placement-order]="hintPlacementOrderStringified"
    (click)="handleButtonClick()"
    (keyup.enter)="handleButtonClick()"
    #buttonElement
  >
    <div *ngIf="button.icon || button.counter" class="button__icon-wrapper">
      <isp-svg-icon
        *ngIf="button.icon"
        class="button__icon"
        [name]="button.icon"
        [size]="button.size === 'small' ? '15px' : '20px'"
      ></isp-svg-icon>
      <div *ngIf="button.counter" class="button__counter">
        {{ button.counter }}
      </div>
    </div>

    {{ button.label }}
  </button>
</ispui-preloader-round>
